/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Reply",
  size: 20
}

const SvgReply = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M17.7 13.11c-1.58-3.09-3.86-5.26-6.68-6.5-.45-.2-1.27-.48-2.02-.7V2L1 9l8 7v-3.87c1.78.34 3.5 1.06 5.09 2.12 3.04 2.03 4.47 4.29 4.47 4.29s.25-3.26-.86-5.43zm-2.88.42C13.17 12.4 11.01 11.4 8 10.92v2.71L2.55 9 8 4.25V6.8c.3.06 1.16.22 2.37.69 2.93 1.16 5.17 3.47 6.28 5.59.32.62.83 1.78 1.03 2.92-.81-.95-1.95-1.85-2.86-2.47z" />
  </Svg>
)

SvgReply.defaultProps = defaultProps
export default SvgReply
